exports.install = function (Vue, options) {
	Vue.prototype.api.Aerationoperate = {
		read(value)//获取增氧操作单条数据
		{
			return Vue.prototype.axiosget("/api/Aerationoperate/read",value)
			.then((response)=>{
				return response;
			});
		},
		getList(value={})//获取增氧操作列表数据
		{
			value.devicesId=Vue.prototype.route.query.id;
			return Vue.prototype.axiosget("/api/Aerationoperate/getList",value)
			.then((response)=>{
				if(response.data.code==1)
				{
					Vue.prototype.$store.commit('Aerationoperate',response.data.data);
				}
				return response;
			});
		},
		// add(value)//添加增氧操作
		// {
		// 	return Vue.prototype.axiospost("/api/Aerationoperate/add",value)
		// 	.then((response)=>{
		// 		return response;
		// 	});
		// },
		// update(value)//修改增氧操作
		// {
		// 	return Vue.prototype.axiospost("/api/Aerationoperate/update",value)
		// 	.then((response)=>{
		// 		return response;
		// 	});
		// },
		// delete(value)//删除增氧操作
		// {
		// 	return Vue.prototype.axiospost("/api/Aerationoperate/delete",value)
		// 	.then((response)=>{
		// 		return response;
		// 	});
		// }
	};
}
